import Axios from 'axios'
import { AUTH_URL, getErrorMessage } from '@/main'

const state = {
  user: null,
  session: null,
  privileges: null,
}

const getters = {
  isAuthenticated: (state) => !!state.session,
  isAdmin: (state) => !!state.session && state.session.privileges.includes('admin'),
  USER: (state) => state.user,
  SESSION: (state) => state.session,
  PRIVILEGES: (state) => state.privileges,
}

const mutations = {
  setUser(state, username) {
    state.user = username
  },
  setSession(state, session) {
    state.session = session
  },
  logout(state) {
    state.user = null
    state.session = null
    state.privileges = null
  },
  setPrivileges(state, privileges) {
    state.privileges = privileges
  },
}

const actions = {}

export function prepareAuthMetadata(context) {
  Axios.get(`${AUTH_URL}/metadata`)
    .then((response) => {
      context.commit('setPrivileges', response.data.privileges)
      context.commit('setFeatures', { auth: { category: 'module' } })
    })
    .catch((error) => {
      console.warn('AUTH module is not available: %o', getErrorMessage(error))
      context.commit('removeFeature', { auth: {} })
    })
}

export default {
  state,
  getters,
  actions,
  mutations,
}
